
import { defineComponent, PropType, computed } from 'vue';

import { LEVELUP_LEARNING } from '@/constants';
import { Pokemon, Move, MoveIdLearning } from '@/types';

export default defineComponent({
  props: {
    moves: {
      type: Object as PropType<Move[]>,
      required: true,
    },
    pokemon: {
      type: Object as PropType<Pokemon>,
      required: true,
    },
    searchMove: {
      type: Object as PropType<Move | null>,
      default: null,
    },
  },
  setup(props) {
    const findMove = (moveId: string): Move => {
      return props.moves.find((m) => m.id === moveId) || { id: '', pageURL: '', name: '', type: '' };
    };
    const move = computed(() =>
      props.searchMove ? findMove(props.searchMove.id) : { id: '', pageURL: '', name: '', type: '' }
    );

    const createLearnedByString = (learnings: MoveIdLearning[], moveId: string): string => {
      const learningBys = learnings.filter((l) => l.id === moveId);
      const byLevelUp = learningBys.find((learningBy) => learningBy.learningBy === LEVELUP_LEARNING);

      return byLevelUp ? `Lv.${byLevelUp.learningLevel}` : '教え技';
    };
    const learnedByString = computed(() =>
      props.searchMove ? createLearnedByString(props.pokemon.moveIdLearnings, props.searchMove.id) : ''
    );

    const isSameTypeMove = (pokemon: Pokemon, moveId: string): boolean => {
      const move = props.moves.find((m) => m.id === moveId);

      return pokemon.types.some((t) => move && move.type === t);
    };
    const isSameType = computed(() => (props.searchMove ? isSameTypeMove(props.pokemon, props.searchMove.id) : false));

    return {
      searchMoves: props.searchMove,
      move,
      learnedByString,
      isSameType,
    };
  },
});
